/**
 * English translations
 */
export default {
  common: {
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    none: 'None',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Info',
    update: 'Update',
    current: 'current',
  },
  welcome: {
    title: 'BitTask',
    subtitle: 'Pixel Todo',
    start: 'Start',
    skipForever: "Don't show again",
    version: 'v1.0.0 - Offline Ready',
  },
  home: {
    title: 'Tasks',
    newTask: 'New Task',
    noTasks: 'No tasks yet',
    addFirstTask: 'Add your first task!',
    completed: 'Completed',
    pending: 'Pending',
    total: 'Total',
    filterAll: 'All',
    filterActive: 'Active',
    filterCompleted: 'Completed',
  },
  task: {
    title: 'Title',
    titlePlaceholder: 'Enter task title',
    titleRequired: 'Title is required',
    description: 'Description',
    descriptionPlaceholder: 'Add a description (optional)',
    priority: 'Priority',
    priorityLow: 'Low',
    priorityMedium: 'Medium',
    priorityHigh: 'High',
    tags: 'Tags',
    tagsPlaceholder: 'Separate tags with commas',
    completed: 'Completed',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    deleteConfirm: 'Delete this task?',
    deleteTask: 'Delete Task',
    deleteTaskConfirm: 'Are you sure you want to delete this task? This action cannot be undone.',
    deleteAttachment: 'Delete Attachment',
    deleteAttachmentConfirm: 'Are you sure you want to delete this attachment? This action cannot be undone.',
    attachments: 'Attachments',
    noAttachments: 'No attachments',
    addAttachment: 'Add attachment',
  },
  attachments: {
    title: 'Attachments',
    addFile: 'Add File',
    addLink: 'Add Link',
    takePhoto: 'Take Photo',
    uploadImage: 'Upload Image',
    uploadAudio: 'Upload Audio',
    uploadPdf: 'Upload PDF',
    deleteConfirm: 'Delete this attachment?',
    previewUnavailable: 'Preview unavailable',
    openLink: 'Open link',
    fileTooBig: 'File too large (max {{size}})',
    invalidType: 'File type not supported',
    linkPlaceholder: 'Enter or paste a URL',
    addLinkButton: 'Add',
  },
  camera: {
    title: 'Camera',
    capture: 'Capture',
    retake: 'Retake',
    usePhoto: 'Use Photo',
    switchCamera: 'Switch Camera',
    permissionDenied: 'Camera access denied',
    permissionHelp: 'Please enable camera permissions in your browser settings.',
  },
  settings: {
    title: 'Settings',
    theme: 'Theme',
    themeSlso8: 'SLSO8',
    themeOriginal: 'Original',
    mode: 'Mode',
    modeLight: 'Light',
    modeDark: 'Dark',
    modeSystem: 'System',
    currentMode: 'Current: {{mode}}',
    language: 'Language',
    storage: 'Storage',
    maxFileSize: 'Max file size',
    compressImages: 'Compress images',
    imageQuality: 'Image quality',
    appStatus: 'App Status',
    installed: 'Installed',
    network: 'Network',
    online: 'Online',
    offline: 'Offline',
    pendingSync: 'Pending sync',
    operations: 'operations',
    installApp: 'Install App',
    showWelcome: 'Show welcome screen',
    about: 'About',
    version: 'BitTask v1.0.0',
    aboutDescription: 'A pixel-art PWA todo app with offline-first architecture.',
    builtWith: 'Built with React, TypeScript, Dexie, and Vite.',
  },
  errors: {
    generic: 'Something went wrong',
    networkError: 'Network error',
    notFound: 'Not found',
    taskNotFound: 'Task not found',
    failedToCreate: 'Failed to create',
    failedToUpdate: 'Failed to update',
    failedToDelete: 'Failed to delete',
    failedToLoad: 'Failed to load',
  },
  boards: {
    title: 'Boards',
    manage: 'Manage Boards',
    create: 'New Board',
    rename: 'Rename',
    delete: 'Delete Board',
    deleteConfirm: 'Are you sure you want to delete this board? All tasks will be moved to another board.',
    cannotDeleteLast: 'Cannot delete the last board',
    transfer: 'Move to...',
    selectBoard: 'Select a board',
    namePlaceholder: 'Board name',
    nameRequired: 'Board name is required',
  },
  subtasks: {
    title: 'Checklist',
    add: 'Add',
    placeholder: 'Add an item...',
    progress: '{{completed}}/{{total}}',
  },
  share: {
    title: 'Shared Content',
    receivedContent: 'Received content',
    createTask: 'Create New Task',
    assignToTask: 'Assign to Existing Task',
    dismiss: 'Dismiss',
    searchPlaceholder: 'Search by #ID or title...',
    untitledTask: 'Shared Item',
    errorReceiving: 'Error receiving shared content',
    timeout: 'Share request timed out',
  },
  speech: {
    start: 'Start voice input',
    stop: 'Stop voice input',
    notSupported: 'Voice input not supported in this browser',
  },
} as const;
